var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaaya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 50,
    viewBox: "0 0 157 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_309_7318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.9989 34.6662V35.2648H57.7949V34.6662C58.3936 34.6662 58.9922 34.5573 59.4275 34.2852C59.9173 34.0131 60.1894 33.741 60.2983 33.5233L70.9104 7.83667H72.0532L82.1755 31.9451C82.2843 32.2717 82.4476 32.4893 82.6653 32.5982C82.883 32.707 83.0462 32.7615 83.2639 32.7615C83.6449 32.7615 84.0802 32.5982 84.5156 32.3261C84.951 32.054 85.2775 31.7819 85.5496 31.5098C85.5496 32.054 85.3863 32.5982 85.1142 33.088C84.8421 33.5778 84.4612 33.9587 83.9714 34.3397C83.4816 34.6662 82.9374 34.9383 82.3388 35.156C81.7401 35.3737 81.0327 35.4281 80.3796 35.4281C79.6721 35.4281 79.0191 35.3192 78.4749 35.156C77.9307 34.9383 77.4409 34.7206 77.0599 34.3397C76.679 34.0131 76.3525 33.6322 76.0804 33.1968C75.8082 32.7614 75.5906 32.3805 75.3729 31.8907L73.4137 27.2105H64.1078L61.55 33.4145C61.4955 33.5778 61.4955 33.6866 61.4955 33.741C61.4955 34.122 61.7677 34.3397 62.3119 34.4485C62.7472 34.6118 63.3459 34.6662 63.9989 34.6662ZM64.4343 26.2854H72.9239L68.6247 16.0542L64.4343 26.2854Z",
    fill: "url(#paint0_linear_309_7318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M92.733 34.6662V35.2648H86.5291V34.6662C87.1277 34.6662 87.7263 34.5573 88.1617 34.2852C88.6515 34.0131 88.9236 33.741 89.0324 33.5233L99.5901 7.83667H100.733L110.855 31.9451C110.964 32.2717 111.127 32.4893 111.345 32.5982C111.563 32.707 111.726 32.7615 111.944 32.7615C112.325 32.7615 112.76 32.5982 113.195 32.3261C113.631 32.054 113.957 31.7819 114.229 31.5098C114.229 32.054 114.066 32.5982 113.794 33.088C113.522 33.5778 113.141 33.9587 112.651 34.3397C112.161 34.6662 111.617 34.9383 111.018 35.156C110.42 35.3737 109.712 35.4281 109.059 35.4281C108.352 35.4281 107.699 35.3192 107.155 35.156C106.61 34.9383 106.121 34.7206 105.74 34.3397C105.359 34.0131 105.032 33.6322 104.76 33.1968C104.488 32.7615 104.27 32.3805 104.053 31.8907L102.093 27.2105H92.7875L90.2297 33.4145C90.1753 33.5778 90.1753 33.6866 90.1753 33.741C90.1753 34.122 90.4474 34.3397 90.9916 34.4485C91.4814 34.6118 92.08 34.6662 92.733 34.6662ZM93.114 26.2854H101.658L97.3588 16.0542L93.114 26.2854Z",
    fill: "url(#paint1_linear_309_7318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M108.461 11.6461C108.461 10.8298 108.624 10.1768 108.95 9.68698C109.277 9.19719 109.658 8.81625 110.093 8.54414C110.529 8.27204 111.018 8.10877 111.454 7.99993C111.944 7.89109 112.325 7.83667 112.542 7.83667C114.12 7.83667 115.372 8.1632 116.352 8.87067C117.277 9.52372 118.039 10.3945 118.529 11.374L124.297 22.8568L130.229 9.79582C130.283 9.63256 130.338 9.52372 130.338 9.36046C130.338 8.97951 130.066 8.76183 129.522 8.7074C128.977 8.65298 128.215 8.59856 127.345 8.59856V7.99993H134.746V8.59856C134.202 8.59856 133.766 8.59856 133.44 8.59856C133.113 8.59856 132.841 8.65298 132.624 8.76183C132.406 8.81625 132.243 8.97951 132.079 9.08835C131.916 9.25161 131.807 9.4693 131.644 9.7414L124.841 24.7072V31.3465C124.841 31.8907 124.841 32.4349 124.896 32.8703C124.95 33.3057 125.005 33.6322 125.168 33.9043C125.331 34.1764 125.549 34.3397 125.875 34.5029C126.202 34.6118 126.637 34.7206 127.236 34.7206V35.3192H116.134V34.7206C116.733 34.7206 117.168 34.6662 117.495 34.5029C117.821 34.3941 118.039 34.1764 118.202 33.9043C118.365 33.6322 118.42 33.3057 118.474 32.8703C118.474 32.4349 118.529 31.9451 118.529 31.3465V25.1425L111.617 11.3196C111.399 10.8298 111.018 10.6121 110.529 10.6121C109.767 10.6121 109.114 10.9387 108.461 11.6461Z",
    fill: "url(#paint2_linear_309_7318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M135.073 34.6662V35.2648H128.869V34.6662C129.467 34.6662 130.066 34.5573 130.501 34.2852C130.991 34.0131 131.263 33.741 131.372 33.5233L141.984 7.83667H143.127L153.249 31.9451C153.358 32.2717 153.521 32.4893 153.739 32.5982C153.957 32.707 154.12 32.7615 154.338 32.7615C154.719 32.7615 155.154 32.5982 155.589 32.3261C156.025 32.054 156.351 31.7819 156.623 31.5098C156.623 32.054 156.46 32.5982 156.188 33.088C155.916 33.5778 155.535 33.9587 155.045 34.3397C154.555 34.6662 154.011 34.9383 153.412 35.156C152.814 35.3737 152.106 35.4281 151.453 35.4281C150.746 35.4281 150.093 35.3192 149.549 35.156C149.004 34.9383 148.515 34.7206 148.134 34.3397C147.753 34.0131 147.426 33.6322 147.154 33.1968C146.882 32.7615 146.664 32.3805 146.447 31.8907L144.487 27.2105H135.181L132.624 33.4145C132.569 33.5778 132.569 33.6866 132.569 33.741C132.569 34.122 132.841 34.3397 133.386 34.4485C133.821 34.6118 134.42 34.6662 135.073 34.6662ZM135.508 26.2854H144.052L139.753 16.0542L135.508 26.2854Z",
    fill: "url(#paint3_linear_309_7318)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.5236 36.843C17.5236 36.843 17.5781 36.5709 17.5781 36.0811C17.6869 33.9042 17.1427 27.3737 7.94556 22.4758C7.94556 22.4758 11.3197 33.741 16.5441 36.843C16.5441 36.843 15.1835 32.3804 12.789 29.6594C12.789 29.6594 14.2584 29.3329 16.2175 31.8906C16.2175 31.8906 17.6869 34.394 17.5236 36.843Z",
    fill: "url(#paint4_linear_309_7318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.8365 36.462C15.8365 36.462 6.96588 33.7954 0 36.462C0 36.462 8.10872 42.2306 17.7412 37.4416C17.7412 37.4416 11.7549 39.945 7.99988 36.8974L16.8161 37.0062C16.8161 37.0062 16.1086 36.6797 15.8365 36.462Z",
    fill: "url(#paint5_linear_309_7318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.5509 25.9587L12.6802 25.1968C12.9523 25.4145 13.2788 25.6866 13.5509 25.9587Z",
    fill: "url(#paint6_linear_309_7318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.8903 35.2104V35.8634H44.1354L43.9721 35.428C43.9721 35.428 44.7884 35.2648 45.9313 34.9383C47.0741 34.6117 46.2578 30.2036 46.2578 30.2036L41.7953 8.70737L32.7614 29.7683C32.7614 29.7683 27.8091 43.1558 17.9045 44.9517C9.6325 45.8224 8.87061 43.047 8.87061 43.047C20.8432 48.1625 27.4826 31.2921 27.4826 31.2921L18.5575 10.0135L13.5508 25.9588C13.2787 25.6867 13.0066 25.4146 12.6801 25.1969C11.5917 24.2718 10.34 23.4554 10.34 23.4554L15.129 8.70737L17.8501 0.0544434L28.8431 29.2241L30.3669 25.7411C36.6253 9.306 40.6524 4.24485 42.8837 2.82991C47.5095 -0.272082 51.6999 3.42854 51.8631 3.5918C47.0741 0.979599 44.1898 5.82306 44.1898 5.82306C44.1898 5.82306 48.7067 25.5779 50.0672 30.5846C51.3189 35.5913 55.8903 35.2104 55.8903 35.2104Z",
    fill: "url(#paint7_linear_309_7318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.367 4.6802C31.6594 4.6802 32.7071 3.6325 32.7071 2.3401C32.7071 1.0477 31.6594 0 30.367 0C29.0746 0 28.0269 1.0477 28.0269 2.3401C28.0269 3.6325 29.0746 4.6802 30.367 4.6802Z",
    fill: "url(#paint8_linear_309_7318)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_309_7318",
    x1: 71.6723,
    y1: 7.83667,
    x2: 71.6723,
    y2: 35.4281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_309_7318",
    x1: 100.379,
    y1: 7.83667,
    x2: 100.379,
    y2: 35.4281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_309_7318",
    x1: 121.603,
    y1: 7.83667,
    x2: 121.603,
    y2: 35.3192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_309_7318",
    x1: 142.746,
    y1: 7.83667,
    x2: 142.746,
    y2: 35.4281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_309_7318",
    x1: 12.7672,
    y1: 22.4758,
    x2: 12.7672,
    y2: 36.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_309_7318",
    x1: 8.87061,
    y1: 35.2769,
    x2: 8.87061,
    y2: 39.3427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_309_7318",
    x1: 13.1155,
    y1: 25.1968,
    x2: 13.1155,
    y2: 25.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_309_7318",
    x1: 32.3804,
    y1: 0.0544434,
    x2: 32.3804,
    y2: 45.1208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_309_7318",
    x1: 30.367,
    y1: 0,
    x2: 30.367,
    y2: 4.6802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_7318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.609,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaaya);
export default __webpack_public_path__ + "static/media/maaya.9afe4b75994b40228b9308879cb05b94.svg";
export { ForwardRef as ReactComponent };